var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counterKey > 0)?_c('div',{style:(_vm.themeColors),attrs:{"id":"app"}},[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }